module.exports = __webpack_public_path__ + "img/nav-stonesize-2.dd91abc.svg";